import {
    SPECIESLIST_REQUEST,
    SPECIESLIST_ERROR,
    SPECIESLIST_SUCCESS,
    SPECIESLIST_params
} from "../actions/speciesList";
import apiCalls from "utils/api";
import store from '../../store';
import Vue from "vue";

const state = {
    speciesList: [],
    speciesListStatus: "",
};

const getters = {
    getSpeciesList: state => state.speciesList,
    isSpeciesListLoaded: state => !!state.speciesList,
    getSpeciesListStatus: state => state.speciesListStatus,
    getSpeciesListTotalWeight: state => state.speciesList.reduce((result, el) => { return result + el.Weight }, 0),
};

const actions = {
    [SPECIESLIST_REQUEST]: ({ commit, dispatch }) => {
        commit(SPECIESLIST_REQUEST);
        var tripLineId = null;

        if (store.state.ordersList.ordersList.length > 0)
            tripLineId = store.state.ordersList.ordersList[0].TripLineId;

        var filter = [
            {
                Filters: [
                    {
                        name: 'TripLineId',
                        value: tripLineId,
                        operator: '='
                    }
                ]
            }
        ];

        SPECIESLIST_params.filter = JSON.stringify(filter);

        apiCalls.apiCall({ url: "get", method: "GET", params: SPECIESLIST_params })
            .then(resp => {
                commit(SPECIESLIST_SUCCESS, resp.data);            
            })
            .catch(() => {
                commit(SPECIESLIST_ERROR);
            });
    }
};

const mutations = {
    [SPECIESLIST_REQUEST]: state => {
        state.speciesListStatus = "loading";
    },
    [SPECIESLIST_SUCCESS]: (state, resp) => {
        state.speciesListStatus = "success";
        state.speciesList = resp.data;
        Vue.set(state, "speciesList", resp.data);
    },
    [SPECIESLIST_ERROR]: state => {
        state.speciesListStatus = "error";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};